/**
 * DetailHeroContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Container for the detail hero section.
 */
const DetailHeroContainer = styled.div<React.CSSProperties>`
  display: flex;
  flex-direction: row;
  margin-bottom: ${24 * Screen.widthRatio}px;
`;

export default DetailHeroContainer;
